import React, { memo, useCallback, useEffect, useState } from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { PapiroConsole } from '../../../utils/papiroConsole'
import '../styles.css'
import { Grid, Typography, Tooltip, IconButton } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SettingsIcon from '@mui/icons-material/Settings';

export function DndItemContainer(props) {
  const [organizationFieldBlockItemList, setOrganizationFieldBlockItemList] = useState(props.organizationFieldBlockItemList)

  useEffect(() => {
    setOrganizationFieldBlockItemList(props.organizationFieldBlockItemList)
  }, [props.organizationFieldBlockItemList])

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(organizationFieldBlockItemList)
    const [reorderedItem] = items.splice(result.source.index, 1)
    items.splice(result.destination.index, 0, reorderedItem)

    setOrganizationFieldBlockItemList(items)
    props.setOrganizationFieldBlockItemList(items)
  }

  const handleOpenDeleteOrganizationFieldBlockDialog = (id, title) => {
    PapiroConsole.log("=== handleOpenDeleteOrganizationFieldBlockItemDialog ===")
    PapiroConsole.log(`${id}: ${title}`)
    props.openDeleteOrganizationFieldBlockDialog(id, title)
  }

  const handleOpenEditOrganizationFieldBlockDialog = (item) => {
    PapiroConsole.log("=== handleOpenEditOrganizationFieldBlockDialog ===")
    PapiroConsole.log(item)
    props.openEditOrganizationFieldBlockDialog(item)
  }

  return (
    <Grid item xs={12} sm={12} style={{ marginTop: 25, border: '1px dashed rgba(0, 0, 0, .6)', borderRadius: 10, backgroundColor: '#eee' }}>
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable droppableId='orgfieldblocks'>
        {(provided) => (
          <ul style={{ margin: 15 }} className='orgfieldblocks' {...provided.droppableProps} ref={provided.innerRef} >
        {organizationFieldBlockItemList.map((item, index) => {
          return (<Draggable key={item.id} draggableId={`${item.id}`} index={index}>
          {(provided) => (
            <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
              <Grid container spacing={0} >
                <Grid item xs={10} md={10} style={{ display: 'flex', alignItems: 'center' }} >
                  <Typography style={{ fontWeight: 'normal' }} variant="body1">{ item.organizationfield.name }</Typography>
                </Grid>
                <Grid item xs={1} md={1}>
                  <Tooltip title={<h5><FormattedMessage id="edit" /></h5>}>
                    <IconButton aria-label='edit'
                      onClick={() => {handleOpenEditOrganizationFieldBlockDialog(item)}} >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                </Grid>
                <Grid item xs={1} md={1}>
                  <Tooltip title={<h5><FormattedMessage id="delete" /></h5>}>
                    <IconButton aria-label='delete'
                      onClick={() => {handleOpenDeleteOrganizationFieldBlockDialog(item.id, item.organizationfield.name)}} >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </li>
          )}
          </Draggable>)
        })}
            {provided.placeholder}
          </ul>
          )}
        </Droppable>
      </DragDropContext>
    </Grid>
  )
}